// File#: _menu-drilldown
// Adds multi-level drilldown navigation for normalized WordPress menu trees.

(function () {
  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderList(items) {
    var html = '<ul class="menu-drilldown__list js-menu-drilldown__list">';

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item) continue;

      var linkTarget = item.target || (item.is_external ? '_blank' : '');
      var targetAttr = linkTarget ? ' target="' + escapeHtml(linkTarget) + '"' : '';
      var relAttr = linkTarget === '_blank' ? ' rel="noopener noreferrer"' : '';
      var currentAttr = item.is_current ? ' aria-current="page"' : '';
      var linkClass = 'menu-drilldown__link';
      if (item.is_current) linkClass += ' menu-drilldown__link--current';
      if (item.is_current_branch) linkClass += ' menu-drilldown__link--current-branch';

      html += '<li class="menu-drilldown__item">';
      html +=
        '<a class="' +
        linkClass +
        '" href="' +
        escapeHtml(item.link || '#') +
        '"' +
        targetAttr +
        relAttr +
        currentAttr +
        '>' +
        escapeHtml(item.label || '') +
        '</a>';

      if (item.has_children && Array.isArray(item.children) && item.children.length > 0) {
        html +=
          '<button class="reset menu-drilldown__drill js-menu-drilldown__drill" type="button" data-label="' +
          escapeHtml(item.label || '') +
          '" data-children="' +
          escapeHtml(JSON.stringify(item.children)) +
          '" aria-label="Unterpunkte öffnen">' +
          '<svg class="icon" viewBox="0 0 16 16" aria-hidden="true">' +
          '<g stroke-width="1" stroke="currentColor">' +
          '<polyline fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="6.5,3.5 11,8 6.5,12.5 "></polyline>' +
          '</g>' +
          '</svg>' +
          '</button>';
      }

      html += '</li>';
    }

    html += '</ul>';

    return html;
  }

  function setCurrentLabel(navEl, label) {
    var currentEl = navEl.querySelector('.js-menu-drilldown__current');
    if (currentEl) currentEl.textContent = label || '';
  }

  function setBackVisibility(navEl, isVisible) {
    var backBtn = navEl.querySelector('.js-menu-drilldown__back');
    if (!backBtn) return;

    if (isVisible) {
      backBtn.removeAttribute('hidden');
    } else {
      backBtn.setAttribute('hidden', '');
    }
  }

  function animateSlide(navEl, direction) {
    navEl.classList.remove('menu-drilldown--slide-forward', 'menu-drilldown--slide-back');
    // eslint-disable-next-line no-unused-expressions
    navEl.offsetHeight;
    navEl.classList.add(direction === 'back' ? 'menu-drilldown--slide-back' : 'menu-drilldown--slide-forward');
  }

  function parseChildren(buttonEl) {
    var rawChildren = buttonEl.getAttribute('data-children');
    if (!rawChildren) return [];

    try {
      var children = JSON.parse(rawChildren);
      return Array.isArray(children) ? children : [];
    } catch (error) {
      return [];
    }
  }

  function initMenuDrilldown(navEl) {
    var listEl = navEl.querySelector('.js-menu-drilldown__list');
    if (!listEl) return;

    var rootLabel = navEl.getAttribute('data-root-label') || '';
    var rootListHtml = listEl.outerHTML;
    var stack = [{ label: rootLabel, items: null }];

    setCurrentLabel(navEl, rootLabel);
    setBackVisibility(navEl, false);

    navEl.addEventListener('click', function (event) {
      var drillBtn = event.target.closest('.js-menu-drilldown__drill');
      if (drillBtn) {
        event.preventDefault();
        event.stopPropagation();

        var children = parseChildren(drillBtn);
        if (children.length < 1) return;

        stack.push({
          label: drillBtn.getAttribute('data-label') || rootLabel,
          items: children,
        });

        animateSlide(navEl, 'forward');
        listEl.outerHTML = renderList(children);
        listEl = navEl.querySelector('.js-menu-drilldown__list');
        setCurrentLabel(navEl, stack[stack.length - 1].label);
        setBackVisibility(navEl, true);
        return;
      }

      var backBtn = event.target.closest('.js-menu-drilldown__back');
      if (!backBtn || stack.length <= 1) return;

      event.preventDefault();
      event.stopPropagation();

      stack.pop();

      animateSlide(navEl, 'back');

      if (stack.length === 1) {
        listEl.outerHTML = rootListHtml;
      } else {
        listEl.outerHTML = renderList(stack[stack.length - 1].items || []);
      }

      listEl = navEl.querySelector('.js-menu-drilldown__list');
      setCurrentLabel(navEl, stack[stack.length - 1].label);
      setBackVisibility(navEl, stack.length > 1);
    });
  }

  var navs = document.getElementsByClassName('js-menu-drilldown');
  if (!navs || navs.length === 0) return;

  for (var i = 0; i < navs.length; i++) {
    initMenuDrilldown(navs[i]);
  }
})();
